/**
 * GraphQL Query
 * ポイント
 */

/**
 * ポイント履歴一覧
 */

export const GRAPH_QL_QUERY_POINT_LIST =
`
  query {
    points {
      edges {
        node {
          id
          customer {
            id
            uuid
            nos {
              id
              no
              type
              priority
            }
            personalInfo {
              lastName
              secondName
              firstName
              suffix
              lastNameKana
              firstNameKana
              phone
              email
            }
            point
            limitedPoint
            limitedPointExpires
            rank {
              code
              name
              pointCoef
            }
          }
          customerNo
          point
          isLimited
          expires
          pointType
          reasonCode
          note
          memo
          createdAt
        }
      }
      totalCount
    }
  }
`



// WEBPACK FOOTER //
// ./src/queries/point.js